<div class="d-flex justify-content-center">
    <div class="spinner-border m-5 text-primary" role="status"></div>
</div>